import {
  apiRequest,
  deleteResource,
  getResource,
  sendForSuccess,
} from "../api/http";

export function getFAQList() {
  return getResource("/api/faq/get-all-faq");
}

export function addFAQ(obj) {
  return sendForSuccess("post", "/api/faq/add-faq", obj);
}

export function updateFAQ(obj, faq_id) {
  return apiRequest("put", `/api/faq/update-faq/${faq_id}`, { data: obj });
}

export function deleteFAQ(faq_id) {
  return deleteResource(`/api/faq/delete-faq/${faq_id}`);
}
